import React from "react";
import UploadDialog from "./UploadDialog.js";

import { withStyles } from "@mui/styles";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import MuiDialogTitle from "@mui/material/DialogTitle";
import MuiDialogContent from "@mui/material/DialogContent";
import MuiDialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Typography from "@mui/material/Typography";
import PublishIcon from "@mui/icons-material/Publish";

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: '16px',
  },
  closeButton: {
    position: "absolute",
    right: '8px',
    top: '8px',
    color: '#9e9e9e',
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: '16px',
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: '8px',
  },
}))(MuiDialogActions);

export default function UploadDocument(props) {
  const {refetch, accountTemplates} = props;
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  const refreshTable = () => {
    refetch();
  };

  return (
    <div>
      <Button
        variant="outlined"
        style={{
          color: "#FFFFFF",
          backgroundColor: "#91c240",
          fontWeight: "normal",
          marginLeft: "15px",
          fontWeight: "bold",
          height: "40px",
          fontSize: "0.8rem",
        }}
        onClick={handleClickOpen}
      >
        <PublishIcon fontSize="small" />
        Import
      </Button>
      <Dialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
      >
        <DialogTitle id="customized-dialog-title" onClose={handleClose}>
          Importer un fichier
        </DialogTitle>
        <DialogContent dividers>
          <UploadDialog closeModal={handleClose} refetch={refreshTable} accountTemplates={accountTemplates}/>
        </DialogContent>
        <DialogActions />
      </Dialog>
    </div>
  );
}
